
// Test data for Level 2 Putting Training

export const puttingTests = [
  {
    id: "putts-plat",
    title: "Les putts à plat",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles aux points D=1,2m, E=1,5m, F=3m et jouer successivement. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-montee",
    title: "Les putts en montée",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en montée sur les points D1=1,2m, E1=1,5m, F1=3m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-descente",
    title: "Les Putts en descente",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en descente aux points D2=1,2m, E2=1,5m, F2=3m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-pente",
    title: "Les Putts en Pente gauche droite",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en pente gauche droite aux points D3=1,2m, E3=1,5m, F3=3m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  },
  {
    id: "putts-pente-droite",
    title: "Les Putts en Pente droite gauche",
    description: "Sur le green d'entrainement ou sur le parcours, positionner 3 balles en pente droite gauche aux points D4=1,2m, E4=1,5m, F4=3m et jouer successivement une balle par situation. Safe zone : zone située derrière le trou où la balle doit s'arrêter pour qu'un putt soit considéré réussi.",
    icon: "🎯"
  }
];
